<!-- 大屏-标题组件 -->
<template>
  <div class="body">
    <div class="title-profix"></div>
    <div>{{ name }}</div>
  </div>
</template>
<script setup>
import { ref, reactive } from 'vue';
import { useStore } from 'vuex';

// eslint-disable-next-line newline-after-var
const store = useStore(),
  emits = defineEmits(['change']),
  props = defineProps({
    //名称
    name: {
      type: String,
      default: null
    }
  });
</script>
<style lang="scss" scoped>
.body {
  display: flex;
  align-items: center;
  gap: 5px;
  // padding: 10px 0 10px 15px;
  font-size: 15px;
  font-weight: bold;
  color: #12151a;
}
.icon {
  width: 20px;
  height: 20px;
}
.icon-up {
  width: 13px;
  height: 13px;
}
</style>
